export default __webpack_public_path__ + "static/media/1.f89342b1.png";